export default __webpack_public_path__ + "static/media/i-pic.48bc80ef.jpeg";